import { Injectable } from '@angular/core';
import { StatisticQueryDto } from '@osos/shared/api';
import { StatisticQueryPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { StatisticQueryParserService } from '../../parsers/statistic-query-parser/statistic-query-parser.service';
import { ParserFactory } from '../../services';

@Injectable()
export class StatisticQueryFactoryService extends FactoryBase<
  StatisticQueryDto,
  StatisticQueryPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: StatisticQueryParserService,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: StatisticQueryPresenterModel): StatisticQueryDto {
    const parser = this.getParser(
      StatisticQueryDto,
      StatisticQueryPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(model: StatisticQueryDto): StatisticQueryPresenterModel {
    const parser = this.getParser(
      StatisticQueryDto,
      StatisticQueryPresenterModel,
      model.specificationVersion,
    );

    const result = parser.getPresenterModel(model);
    return result;
  }
}
